import {Component, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RegrasDeComponenteKit as C, permiteMultiplaEscolha} from '../../../../server/domain/kit/RegrasDeComponenteKit';

@Component({selector: 'app-componente-kit-montagem', standalone: true, imports: [CommonModule, FormsModule],
  templateUrl: './componente-kit-montagem.component.html', styleUrls: ['./kit-montagem.component.scss']})
export class ComponenteKitMontagemComponent implements OnChanges {
  @Input() item: any;
  @Input() grupo: any;
  @Output() alterou = new EventEmitter<void>();
  aviso = '';
  get config(): any { return this.grupo.configComponenteKit; }
  get estado(): any {
    this.item.adicionais = this.item.adicionais || {};
    const estados = this.item.adicionais.componentesKit || (this.item.adicionais.componentesKit = this.item.componentesKit || []);
    let estado = estados.find((e: any) => e.adicionalId === this.grupo.id);
    if (!estado) {
      estado = {adicionalId: this.grupo.id, qtdeUnidades: this.config.modalidadeQuantidade === 'FIXA' ? this.config.qtdeFixa :
        this.config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE' ? this.config.qtdeMinima : null, quantidadeFechadaId: null};
      estados.push(estado);
    }
    this.item.componentesKit = estados;
    return estado;
  }
  get opcoes(): any[] { return (this.grupo.opcoesDisponiveis || []).filter(o => o.disponivel !== false && !o.esconder && !o.oculta); }
  get quantidades(): any[] { return (this.config.quantidades || []).filter(q => q.disponivel !== false); }
  get lista(): any {
    const indice = this.item.produto.camposAdicionais.filter(permiteMultiplaEscolha).indexOf(this.grupo);
    this.item.adicionais = this.item.adicionais || {};
    const lista = this.item.adicionais['lista' + indice] || (this.item.adicionais['lista' + indice] = {});
    lista.tipoDeCobranca = 'SOMA'; lista.multiplicaQuantidadeProduto = true;
    return lista;
  }
  get escolhas(): any[] { return Object.keys(this.lista).filter(k => k.startsWith('opcao_') && this.lista[k]?.selecionada).map(k => this.lista[k]); }
  get total(): number { return this.escolhas.reduce((s, o) => s + o.qtde, 0); }
  get erro(): string { return C.distribuicao(this.grupo, this.estado, this.escolhas)?.mensagem || ''; }
  get completo(): boolean { return !this.erro; }
  /** Unidades que ainda faltam distribuir; negativo quando sobram. */
  get restante(): number { return (this.estado.qtdeUnidades || 0) - this.total; }
  /** Passo dos botões de opção: grupos grandes andam de 10 em 10, médios de 5 em 5, pequenos de 1 em 1. */
  get passoRapido(): number {
    const n = this.estado.qtdeUnidades || 0;
    return n >= 50 ? 10 : n >= 20 ? 5 : 1;
  }
  get progresso(): number {
    const n = this.estado.qtdeUnidades || 0;
    return n ? Math.min(100, Math.round(this.total / n * 100)) : 0;
  }
  get statusTexto(): string {
    if (this.aviso) return this.aviso;
    if (this.restante > 0) return `Faltam ${this.restante}`;
    if (this.restante < 0) return `Sobram ${-this.restante}`;
    const erro = this.erro;
    return erro ? erro.replace(`${this.grupo.nome}: `, '') : 'Completo ✓';
  }
  /** Atalhos de quantidade na modalidade escolhida pelo cliente: múltiplos do mínimo válidos pelo incremento e pelo máximo. */
  get atalhos(): number[] {
    const c = this.config;
    if (c.modalidadeQuantidade !== 'ESCOLHIDA_PELO_CLIENTE' || !c.qtdeMinima || !c.incremento) return [];
    return [1, 2, 3, 5].map(k => k * c.qtdeMinima)
      .filter(n => (n - c.qtdeMinima) % c.incremento === 0 && (c.qtdeMaxima == null || n <= c.qtdeMaxima));
  }
  get precoGrupo(): number { return C.contribuicao(this.grupo, this.estado).toNumber(); }
  get podeDiminuirUnidades(): boolean { return (this.estado.qtdeUnidades || 0) - this.config.incremento >= this.config.qtdeMinima; }
  get podeAumentarUnidades(): boolean {
    const n = (this.estado.qtdeUnidades || 0) + this.config.incremento;
    return this.config.qtdeMaxima == null || n <= this.config.qtdeMaxima;
  }
  ngOnChanges(): void {
    if (!this.item || !this.grupo) return;
    const estado = this.estado;
    if (this.config.modalidadeQuantidade === 'FIXA' && this.opcoes.length === 1 && !this.escolhas.length)
      this.definir(this.opcoes[0], estado.qtdeUnidades);
  }
  quantidade(o: any): number { return this.lista['opcao_' + o.id]?.qtde || 0; }
  definir(o: any, qtde: number): void {
    if (!Number.isSafeInteger(qtde) || qtde < 0) { this.aviso = 'Informe uma quantidade inteira e positiva.'; return; }
    const minimo = Math.max(this.config.qtdeMinimaPorOpcao, o.qtdeMinima || 1);
    const distintas = this.escolhas.filter(e => e.opcao.id !== o.id).length + (qtde > 0 ? 1 : 0);
    if (qtde > 0 && qtde < minimo) { this.aviso = `${o.nome} precisa de pelo menos ${minimo} unidades.`; return; }
    if (o.qtdeMaxima > 0 && qtde > o.qtdeMaxima) { this.aviso = `${o.nome} permite até ${o.qtdeMaxima} unidades.`; return; }
    if (this.config.qtdeMaximaDeOpcoes != null && distintas > this.config.qtdeMaximaDeOpcoes) {
      this.aviso = `Escolha até ${this.config.qtdeMaximaDeOpcoes} opções diferentes.`; return;
    }
    if (this.total - this.quantidade(o) + qtde > this.estado.qtdeUnidades) {
      this.aviso = `Passa do total de ${this.estado.qtdeUnidades} unidades.`; return;
    }
    this.lista['opcao_' + o.id] = {opcao: o, qtde, selecionada: qtde > 0, valorTotal: qtde * (o.valor || 0)};
    this.lista.totalSelecionado = this.total;
    this.atualize();
  }
  /** Anda pelo passo rápido: de 0 vai direto ao maior entre o mínimo e o passo; ao voltar abaixo do mínimo zera; nunca passa do restante. */
  passo(o: any, delta: number): void {
    const atual = this.quantidade(o), minimo = Math.max(this.config.qtdeMinimaPorOpcao, o.qtdeMinima || 1), passo = this.passoRapido;
    if (delta > 0) {
      const alvo = atual === 0 ? Math.max(minimo, passo) : atual + passo;
      this.definir(o, Math.min(alvo, atual + this.restante));
    } else {
      const alvo = atual - passo;
      this.definir(o, alvo < minimo ? (atual > minimo ? minimo : 0) : alvo);
    }
  }
  completar(o: any): void { this.definir(o, this.estado.qtdeUnidades - this.total + this.quantidade(o)); }
  /** Divide entre as opções já marcadas; sem nenhuma marcada, divide entre todas as opções disponíveis. */
  dividir(): void {
    const n = this.estado.qtdeUnidades;
    if (!n) { this.aviso = 'Escolha a quantidade antes de dividir.'; return; }
    const limite = this.config.qtdeMaximaDeOpcoes != null ? this.config.qtdeMaximaDeOpcoes : this.opcoes.length;
    const escolhidas = this.escolhas.length ? this.escolhas : this.opcoes.slice(0, limite).map(o => ({opcao: o}));
    if (!escolhidas.length) { this.aviso = 'Nenhuma opção disponível para dividir.'; return; }
    const novas = escolhidas.map((e, i) => ({opcao: e.opcao, qtde: Math.floor(n / escolhidas.length) + (i < n % escolhidas.length ? 1 : 0)}));
    const erro = C.distribuicao(this.grupo, this.estado, novas);
    if (erro) { this.aviso = erro.mensagem.replace(`${this.grupo.nome}: `, ''); return; }
    novas.forEach(e => this.lista['opcao_' + e.opcao.id] = {...e, selecionada: true, valorTotal: e.qtde * (e.opcao.valor || 0)});
    this.lista.totalSelecionado = this.total; this.atualize();
  }
  escolhaQuantidade(id: number): void {
    const q = this.quantidades.find(q => q.id === id);
    this.estado.quantidadeFechadaId = id; this.estado.qtdeUnidades = q?.qtdeUnidades;
    this.atualize();
  }
  definaUnidades(n: number): void { this.estado.qtdeUnidades = n; this.atualize(); }
  passoUnidades(delta: number): void {
    const c = this.config, atual = this.estado.qtdeUnidades || c.qtdeMinima;
    let n = atual + delta * c.incremento;
    if (n < c.qtdeMinima) n = c.qtdeMinima;
    if (c.qtdeMaxima != null && n > c.qtdeMaxima) n = atual;
    this.definaUnidades(n);
  }
  atualize(): void { this.aviso = ''; this.item.atualizeTotal?.(); this.alterou.emit(); }
}
